import axios, { AxiosError } from 'axios'
import { useAuthStore } from '../store/authStore'
import { loginPath } from '../utils/loginRedirect'

const API_URL = import.meta.env.VITE_API_URL || '/api'

const client = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

client.interceptors.request.use((config) => {
  const token = useAuthStore.getState().tokens?.access_token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

client.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const requestUrl = error.config?.url || ''

    // Don't intercept 401 from login endpoint - let the Login component handle it
    if (error.response?.status === 401 && !requestUrl.includes('/auth/login')) {
      const refreshToken = useAuthStore.getState().tokens?.refresh_token
      if (refreshToken) {
        try {
          const response = await axios.post(`${API_URL}/auth/refresh`, {
            refresh_token: refreshToken,
          })
          const { tokens } = response.data.data
          useAuthStore.getState().setTokens(tokens)

          if (error.config) {
            error.config.headers.Authorization = `Bearer ${tokens.access_token}`
            return axios.request(error.config)
          }
        } catch {
          const auth = useAuthStore.getState()
          if (auth.impersonator) {
            // Backend režim „Přihlásit se jako" zneplatnil — vrátit se k účtu admina, ne odhlašovat.
            auth.stopImpersonation()
            window.location.href = '/admin/users'
          } else if (auth.tokens?.refresh_token !== refreshToken) {
            // Mezitím se přihlášení změnilo (souběžný požadavek už ukončil impersonaci) — neodhlašovat.
            return Promise.reject(error)
          } else {
            auth.logout()
            window.location.href = loginPath(window.location.pathname + window.location.search)
          }
        }
      } else {
        useAuthStore.getState().logout()
        window.location.href = loginPath(window.location.pathname + window.location.search)
      }
    }
    return Promise.reject(error)
  }
)

export default client
